/**
 * Created by ObadaDarwish on 15/03/2017.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateSortTournament} from './date-sort-tournament';
import {TruncatePipe} from './truncate';
import {SafeUrlPipe} from './safe-url.pipe';
import {SafeHtmlPipe} from './safe-html';
import {filterSearch} from './search';
import {SortParticipants} from './participant-sort';
import {limitNgFor} from './limit-ngFor';
import {orderByPipe} from './orderby';

@NgModule({
  imports: [CommonModule],
  declarations: [orderByPipe, limitNgFor, SortParticipants, filterSearch,
    DateSortTournament, TruncatePipe, SafeUrlPipe, SafeHtmlPipe],
  exports: [orderByPipe, limitNgFor, SortParticipants,
    filterSearch, DateSortTournament, CommonModule, TruncatePipe, SafeUrlPipe, SafeHtmlPipe]
})
export class PipeSahredModule {
}
